import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import async from 'async';
import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import { UiHelper } from '../common/helpers/UiHelper';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { Helper } from '../common/helpers/Helper';
import { Controller } from '../common/Controller';
import { CustomFormFieldsDialogV2 } from '../components/CustomFormFieldsDialogV2';
import { ActionHeaderbar } from '../components/ActionHeaderbar';
import { PopOverV2 } from '../components/PopOverV2';
import { AppHelper } from '../helpers/AppHelper';
import { appData } from '../data/AppData'
import { AppTheme } from '../styles/AppTheme';
import { CommonStyles } from '../styles/Styles';
import { AppConfig } from '../AppConfig';

export class ClientPlaces extends Component {
  constructor(props) {
    super(props);
    this.orgId = this.props.match.params.id ? this.props.match.params.id : null;
    this.responseByKey = {}
    this.unseenPlaceTile = {}
    this.eventUpdateIntervalFnId = null;
    this.state = {
      updateMemberDialog: false,
      confirmDeleteView: false,
      inProcess: false,
      dialogAction: '',
      dialogTitle: '',
      selectedItem: {},
      anchorEl: null,
      fetchState: ApiHelper.State.LOADING,
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.fetchItems();
    // this.eventUpdateIntervalFnId = setInterval(() => {
    //   this.fetchItems();
    // }, AppConfig.eventRefreshInterval); TODO
  }

  componentWillUnmount() {
    if (this.eventUpdateIntervalFnId) {
      clearInterval(this.eventUpdateIntervalFnId);
    }
  }

  fetchItems = () => {
    const thisObj = this;
    async.parallel(
      [
        function (callback) {
          ApiHelper.call(
            { method: 'GET', endPoint: ApiHelper.makeUrlPath(['placesByOrgId'], { orgId: thisObj.orgId }) }, callback)
        },
        function (callback) {
          ApiHelper.call(
            { method: 'GET', endPoint: ApiHelper.makeUrlPath(['orgs', thisObj.orgId]) }, callback)
        },
      ],
      function (err, results) {
        if (err) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        for (const item of results[0]) {
          if (item.loc && item.loc.length === 2) {
            item.lat = item.loc[0]
            item.long = item.loc[1]
          }
        }

        this.setState({
          items: results[0],
          org: results[1],
          fetchState: ApiHelper.State.READY,
        })
      }.bind(this))
  }

  resetToDefaultValues = () => {
    this.responseByKey = {}
    this.setState({
      updateMemberDialog: false,
      inProcess: false,
      dialogAction: '',
      dialogTitle: '',
      selectedItem: {},
      anchorEl: null,
      confirmDeleteView: false,
    })
  }

  showAddMemberDialog = () => {
    this.setState({
      updateMemberDialog: true,
      dialogTitle: 'Add a Place',
      dialogAction: 'add'
    })
  }

  showConfirmDeleteView = () => {
    this.setState({
      confirmDeleteView: true,
      inProcess: false,
      dialogAction: '',
    })
  }

  showDeleteMemberDialog = () => {
    this.responseByKey = this.state.selectedItem
    this.setState({
      anchorEl: null,
      updateMemberDialog: true,
      dialogTitle: 'Delete a Place',
      dialogAction: 'delete',
    })
  }

  showUpdateMemberDialog = () => {
    this.responseByKey = this.state.selectedItem
    this.setState({
      anchorEl: null,
      updateMemberDialog: true,
      dialogTitle: 'Edit a Place',
      dialogAction: 'edit',
    })
  }

  showViewMemberDialog = () => {
    this.responseByKey = this.state.selectedItem
    this.setState({
      anchorEl: null,
      updateMemberDialog: true,
      dialogTitle: 'Place',
      dialogAction: 'viewInfo',
    })
  }

  onPopOverClick = (key) => {
    if (key === 'edit') {
      this.showUpdateMemberDialog()
    } else if (key === 'delete') {
      this.showDeleteMemberDialog()
    } else if (key === 'downloadReport') {
      //Controller.get().pushRoute('/reports/' + this.state.selectedItem._id)
      Controller.get().pushRouteWithParams('/orgs/' + this.orgId + '/reports',
        {
          selectedPlaceIds: [this.state.selectedItem._id]
        })
    } else if (key === 'viewInfo') {
      this.showViewMemberDialog()
    }
  }

  editClick = (e, item) => {
    if (!e) {
      const e = window.event;
      e.cancelBubble = true;
    }
    if (e.stopPropagation) {
      e.stopPropagation();
    }
    this.setState({
      anchorEl: e.currentTarget,
      selectedItem: item
    })
  }

  editClickClose = () => {
    this.setState({ anchorEl: null })
  }

  renderUpdateMemberDialog = () => {
    const formFields = []
    for (const key in appData.placeFields) {
      if (key === 'type') {
        const options = []
        for (const pType of AppConfig.placeTypes) {
          options.push({
            name: pType.name,
            key: pType.key
          })
        }
        appData.placeFields[key].options = options
      }
      formFields.push(appData.placeFields[key])
    }
    return (
      <CustomFormFieldsDialogV2
        onClose={this.resetToDefaultValues}
        dialogOpen={this.state.updateMemberDialog}
        dialogTitle={this.state.dialogTitle}
        confirmDeleteView={this.state.confirmDeleteView}
        inProcess={this.state.inProcess}
        selectedItem={this.state.selectedItem}
        deleteItem={() => this.deleteMember()}
        action={this.state.dialogAction}
        showConfirmDeleteView={this.showConfirmDeleteView}
        responseByKey={this.responseByKey}
        onSuccess={this.addMember}
        formFields={formFields}
        enableValidation={(this.state.dialogAction === 'delete' || this.state.dialogAction === 'viewInfo') ? false : true}
        formDisabled={(this.state.dialogAction === 'delete' || this.state.dialogAction === 'viewInfo') ? true : false}>
      </CustomFormFieldsDialogV2>
    )
  }

  addMember = () => {
    this.setState({
      inProcess: true
    })
    let options = {}
    const id = this.state.selectedItem ? this.state.selectedItem._id : null
    if (!id) {
      options = {
        method: 'POST',
        endPoint: ApiHelper.makeUrlPath(['places']),
        jsonBody: {
          placeData: {
            name: this.responseByKey.name,
            loc: [this.responseByKey.long, this.responseByKey.lat],
            orgId: this.orgId,
            type: this.responseByKey.type,
            logoUrl: this.responseByKey.logoUrl
          }
        }
      }
    } else {
      const body = {
        placeData: {
          name: this.responseByKey.name,
          loc: [this.responseByKey.long, this.responseByKey.lat],
          orgId: this.orgId,
          type: this.responseByKey.type,
          logoUrl: this.responseByKey.logoUrl
        }
      }
      options = {
        method: 'PUT',
        endPoint: ApiHelper.makeUrlPath(['places', id]),
        jsonBody: body
      }
    }
    Helper.removeNullValues(options.jsonBody.userData)
    console.log('options', options)
    ApiHelper.call(options, function (err, data) {
      if (err) {
        const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          errMsg: msg,
          errCode: err.respCode,
          inProcess: false,
        })
        return
      } else {
        this.resetToDefaultValues()
        this.fetchItems();
      }
    }.bind(this))
  }

  deleteMember = () => {
    const id = this.state.selectedItem ? this.state.selectedItem._id : null
    if (!id) {
      return
    }
    this.setState({
      inProcess: true
    })
    const options = {
      method: 'DELETE',
      endPoint: ApiHelper.makeUrlPath(['places', id]),
    }
    ApiHelper.call(options, function (err, data) {
      if (err) {
        const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          errMsg: msg,
          errCode: err.respCode,
          inProcess: false,
        })
        return
      } else {
        this.resetToDefaultValues()
        this.fetchItems();
      }
    }.bind(this))
  }

  onRowItemClick = (item) => {
    Controller.get().pushRouteWithParams(
      '/places/' + item._id + '/cams',
      {
        item: item
      }
    )
  }

  highlight = (item) => {
    let unseenEvent = false
    item.cams.map(cam => {
      if ((item.latestEventTs && moment(cam.lastSeenTs).valueOf() < moment(cam.latestEventTs).valueOf()) || !cam.lastSeenTs) {
        unseenEvent = true
      }
    })
    this.unseenPlaceTile[item._id] = unseenEvent
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  readyView = () => {
    const open = Boolean(this.state.anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (
      <div className={css(CommonStyles.outerMainContainer)}>
        <ActionHeaderbar
          backPathName={Controller.get().userMgr().isProductUser() ? '/orgs/' + this.state.org._id : null}
          title={this.state.org.name}
          items={this.state.items}
          statPrefix={(this.state.items && this.state.items.length > 1) ? 'Places' : 'Place'}
          buttonOneAction={this.showAddMemberDialog}
          buttonOneTitle={'ADD NEW PLACE'}
          inProcess={this.state.inProcess}></ActionHeaderbar>

        {/*TODO: Make the tiles common*/}
        {this.state.items.length !== 0 &&
          <div className={css(CommonStyles.innerMainContainer)}>
            <div className={css(Styles.innerContainer)}>
              <Grid container spacing={4}>
                {this.state.items.map(item => {
                  this.highlight(item)
                  return (
                    <Grid item xs={12} sm={4} md={3} className={css(Styles.tileContainer)}>
                      <div className={this.unseenPlaceTile[item._id] ? css(Styles.tileContent, Styles.tileContentHighlight) : css(Styles.tileContent)}
                        onClick={(e) => this.onRowItemClick(item)}>
                        {/*<div className={css(Styles.ImgOuterContainer)}>
                            <img src={require('../assets/images/location-img.svg')} className={css(Styles.ImgContent)} />
                        </div>*/}
                        <div className={css(Styles.ImgOuterContainer)}>
                          <img
                            src={item.logoUrl ? item.logoUrl : require('../assets/images/location-img.svg')}
                            onError={(e) => {
                              e.target.src = require('../assets/images/error.svg')
                            }} className={css(Styles.ImgContent)} />
                        </div>
                        <div className={css(Styles.tileDetailContainer)}>
                          <div className={css(Styles.placeDetailsCtontainer)}>
                            <p className={css(Styles.tileDetailContainerType)}>{AppHelper.getPlacetype(item.type)}</p>
                            <p className={css(Styles.tileDetailContainerName)}>{item.name}</p>
                          </div>
                          <div className={css(Styles.tileCamDetailContainer)}>
                            <div className={css(Styles.tileCamDetailContent)}>
                              <p className={css(Styles.tileDetailContainerlength)}>{item.cams.length}</p>
                              <img src={require('../assets/images/cam-img.svg')} />
                            </div>
                            <div aria-describedby={id} onClick={(e) => this.editClick(e, item)} className={css(Styles.editContent)} >
                              <img src={require('../assets/images/more-rounded.svg')} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  )
                })}
              </Grid>
            </div>
          </div>
        }

        {this.state.items.length === 0 &&
          <p className={css(CommonStyles.emptyView)}>No Places added yet</p>
        }

        {this.renderUpdateMemberDialog()}

        <PopOverV2
          id={id}
          open={open}
          items={(Controller.get().userMgr().isProductUser() || Controller.get().userMgr().isAdminUser()) ? appData.placeTilePopOverFields : appData.regularPopOverFields}
          anchorEl={this.state.anchorEl}
          onPopOverClick={this.onPopOverClick}
          editClickClose={this.editClickClose}
        />
      </div>
    )
  }
}


const Styles = StyleSheet.create({
  innerContainer: {
    width: '90%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 65,
    marginBottom: 50
  },
  tileContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  tileContent: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '0 10px 10px 10px',
    backgroundColor: AppTheme.secondaryColor,
    position: 'relative',
    border: '2px solid' + AppTheme.secondaryColor,
    cursor: 'pointer',
    /*':hover': {
      border: '2px solid #FF682A'
    }*/
  },
  tileContentHighlight: {
    border: '2px solid #FF682A'
  },
  ImgOuterContainer: {
    width: '100%',
    height: 200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: AppTheme.primaryBackground,
    borderRadius: '0px 10px 0px 0px'
  },
  ImgContent: {
    maxWidth: '100%',
    maxHeight: '100%',
    borderRadius: '0px 10px 0px 0px'
  },
  editContent: {
    marginLeft: 10,
    cursor: 'pointer',
    width: 30,
    height: 30,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ':hover': {
      backgroundColor: AppTheme.primaryBackground,
    }
  },
  tileDetailContainer: {
    display: 'flex',
    padding: 15,
    alignItems: 'center',
    backgroundColor: '#1E2530',
    borderRadius: '0px 0px 10px 10px',
    '@media(max-width: 767px)': {
      //flexDirection: 'column',
      //alignItems: 'flex-start',
      //padding: 10,
    }
  },
  tileDetailContainerName: {
    color: AppTheme.white,
    opacity: 0.7,
    fontSize: AppTheme.fontSizeTitle,
    margin: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  tileDetailContainerType: {
    color: AppTheme.white,
    opacity: 0.5,
    fontSize: AppTheme.fontSizeContent,
    margin: 0
  },
  tileCamDetailContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    //flex: 1,
    '@media(max-width: 767px)': {
      //marginTop: 5,
      //width: '100%',
      //justifyContent: 'flex-start'
    }
  },
  placeDetailsCtontainer: {
    flex: 1,
    overflow: 'hidden'
  },
  tileCamDetailContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  tileDetailContainerlength: {
    color: AppTheme.white,
    opacity: 0.6,
    fontSize: 13,
    fontWeight: 'bold',
    margin: 0,
    marginRight: 10,
  }
})



// WEBPACK FOOTER //
// ./src/screens/ClientPlaces.js